import React from 'react';
import { push } from '../../native/navigator';
import './index.css';
import propTypes from 'prop-types';



CustomPoiLink.propTypes = {
  value: propTypes.string.isRequired,
  type: propTypes.string,
  cityInfo: propTypes.object.isRequired,
  day: propTypes.string.isRequired,
  tripId: propTypes.string.isRequired,
  page: propTypes.string.isRequired
};


export default function CustomPoiLink(props) {
  let { isDemoTrip, value, type, cityInfo, day, tripId, page } = props;
  console.log(page);
  if(value === '' || isDemoTrip){
    return null;
  }
  return (
    <div className="custom-poi-link" onClick={()=>{
      push('/m/v2/?m=render2&page=create-custompoi',{
        trip_id: tripId,
        day,
        value,
        city_id: cityInfo.city,
        lat: cityInfo.lat,
        lng: cityInfo.lng,
        next:page
      });
    }}>
      <i className="icon icon-add-bold"></i>
      <p>自定义{type}：<span>{value}</span></p>
    </div>
  );
}


// WEBPACK FOOTER //
// ./src/components/CustomPoiLink/index.js